//const url = "http://pedidosapp.ddns.net:5002/api";
//const url = "http://192.168.15.69:5002/api";
//const url = "http://192.168.15.254:5002/api";
//const url = "https://gatewaysistemas-app.ddns.net:4443/PedidosAppApi/api";

//Teste em (homologação)
//const url = "https://vps52074.publiccloud.com.br/apihomologacao/api";

//Produção
const url = "https://vps52074.publiccloud.com.br/apiproducao/api";

export default url;
